import { MultiValueRemoveProps, components } from 'react-select';

export function MultiValueRemove({
  innerProps,
  ...otherProps
}: MultiValueRemoveProps) {
  return (
    <components.MultiValueRemove
      innerProps={innerProps}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
    />
  );
}
